CTAMap.api = {
  url: {
    list: window.ys.rest_url + 'cycling_trips/v1/nearby/',
    detail: window.ys.rest_url + 'cycling_trips/v1/detail/',
  },
  xhr: null,
  result: null,
  requestType: null,
  firstRequest: true,
  args: {
    lat: null,
    lng: null,
    page: 1,
  },
};

CTAMap.api.clearArgs = function () {
  CTAMap.api.args.lat = null;
  CTAMap.api.args.lng = null;
  CTAMap.api.args.country = null;
  CTAMap.api.args.radius = null;
  CTAMap.api.args.page = 1;
};

CTAMap.api.setArgsFromForm = function () {
  CTAMap.api.requestType = 'form';
  var keywords = jQuery('.location-search-keyword').val();
  CTAMap.api.args.keywords = keywords ? keywords : null;
  var length = jQuery('.length input[type=radio]:checked').val();
  CTAMap.api.args.length = length ? length : null;
  var route_type = jQuery('.bicycle-type input[type=radio]:checked').val();
  CTAMap.api.args.route_type = route_type ? route_type : null;
  var difficulty = jQuery('.bicycle-for input[type=radio]:checked').val();
  CTAMap.api.args.difficulty = difficulty ? difficulty : null;
  var terrain = jQuery('.terrain input[type=radio]:checked').val();
  CTAMap.api.args.terrain = terrain ? terrain : null;
  CTAMap.api.args.extend_radius = true;
};

CTAMap.api.filterIsSet = function () {
  var check = ['keywords', 'length', 'route_type', 'difficulty', 'terrain'];
  for (var i = 0; i < check.length; i++) {
    if (CTAMap.api.args[check[i]]) {
      return true;
    }
  }
  return false;
};

CTAMap.api.setArgsFromMap = function () {
  CTAMap.api.requestType = 'map';
  CTAMap.api.args.zoom = CTAMap.map.obj.getZoom();
  CTAMap.api.args.lat = CTAMap.map.obj.getCenter().lat();
  CTAMap.api.args.lng = CTAMap.map.obj.getCenter().lng();
  CTAMap.api.args.country = null;
  CTAMap.api.args.page = 1;

  if (CTAMap.map.isVisible()) {
    CTAMap.api.args.radius = CTAMap.map.getRadius();
  } else {
    CTAMap.api.args.radius = CTAMap.place.getRadius();
  }
  delete CTAMap.api.args.extend_radius;
};

CTAMap.api.setArgsFromPlace = function () {
  CTAMap.api.requestType = 'place';
  CTAMap.api.args.zoom = CTAMap.map.obj.getZoom();
  CTAMap.api.args.lat = CTAMap.place.obj.geometry.location.lat();
  CTAMap.api.args.lng = CTAMap.place.obj.geometry.location.lng();
  var counryCode = CTAMap.place.getCoutryCode();
  CTAMap.api.args.country = counryCode ? counryCode : null;

  if (CTAMap.map.isVisible()) {
    CTAMap.api.args.radius = CTAMap.map.getRadius();
  } else {
    CTAMap.api.args.radius = CTAMap.place.getRadius();
  }
  CTAMap.api.args.extend_radius = true;
};

CTAMap.api.setArgsFromLatLng = function () {
  CTAMap.api.requestType = 'latlng';
  CTAMap.api.args.lat = CTAMap.place.lat;
  CTAMap.api.args.lng = CTAMap.place.lng;

  if (CTAMap.map.isVisible()) {
    CTAMap.api.args.radius = CTAMap.map.getRadius();
  } else {
    CTAMap.api.args.radius = CTAMap.place.getRadius();
  }
  delete CTAMap.api.args.extend_radius;
};

CTAMap.api.getUrlArgs = function () {
  var currentUrl = window.location.href.split('?');
  if (currentUrl.length > 1) {
    //if has GET args
    var queryVars = currentUrl[1].split('&');
    var data = {};
    for (var i = 0; i < queryVars.length; i++) {
      var keyAndVariable = queryVars[i].split('=');
      data[keyAndVariable[0]] =
        typeof keyAndVariable[1] !== 'undefined'
          ? decodeURIComponent(keyAndVariable[1])
          : null;
    }
    return data;
  }
  return {};
};

CTAMap.api.setArgsFromUrlAndExecute = function () {
  var args = CTAMap.api.getUrlArgs();

  if (!jQuery.isEmptyObject(args) && typeof args.placeId !== 'undefined') {
    GLSearch.selected.placeId = args.placeId;
    if (args.placeName) {
      GLSearch.selected.placeName = args.placeName;
      GLSearch.getInput().val(GLSearch.selected.placeName);
    }
    jQuery('.location-search-submit').click();
  }

  if (
    !jQuery.isEmptyObject(args) &&
    typeof args.lat !== 'undefined' &&
    typeof args.lng !== 'undefined'
  ) {
    for (var k in args) {
      CTAMap.api.args[k] = args[k];
    }
    CTAMap.queue.disableUntilMapIdle();
    CTAMap.map.obj.setCenter({
      lat: parseFloat(args.lat),
      lng: parseFloat(args.lng),
    });

    CTAMap.view.setFilter(args);

    var listener = google.maps.event.addListener(
      CTAMap.map.obj,
      'idle',
      function () {
        if (typeof args.zoom !== 'undefined') {
          CTAMap.queue.disableUntilMapIdle();
          CTAMap.map.obj.setZoom(parseInt(args.zoom));
          google.maps.event.removeListener(listener);
        }
        CTAMap.queue.start();
      }
    );
  } else {
    jQuery('.location-search-submit').click();
  }
};

CTAMap.api.setArgsFromResult = function () {
  CTAMap.api.requestType = 'result';
  delete CTAMap.api.args.extend_radius;
};

CTAMap.api.getNumberOfAppliedFilters = function () {
  var advancedFilters = ['keywords', 'length', 'route_type', 'terrain'];
  var count = 0;
  for (var i = 0; i < advancedFilters.length; i++) {
    if (
      typeof CTAMap.api.args[advancedFilters[i]] !== 'undefined' &&
      CTAMap.api.args[advancedFilters[i]] &&
      CTAMap.api.args[advancedFilters[i]] !== '0'
    ) {
      count++;
    }
  }
  return count;
};

CTAMap.api.setUrl = function () {
  var url = '';
  var args = CTAMap.api.args;
  for (var key in args) {
    if (args[key] !== null && args[key] !== '0') {
      if (key === 'extend_radius' || key === 'page') {
        continue;
      }
      if (url !== '') {
        url += '&';
      }
      url += key + '=' + encodeURIComponent(args[key]);
    }
  }
  window.history.replaceState(null, null, '?' + url);
};

CTAMap.api.nextPage = function () {
  CTAMap.api.args.page++;
};

CTAMap.api.getResults = function () {
  var request;
  request = jQuery.ajax({
    url: CTAMap.api.url.list,
    method: 'POST',
    data: Object.assign({}, CTAMap.api.args, {
      loaded_quadrants: CTAMap.map.loadedQuadrants.join('|'),
    }),
    dataType: 'json',
  });

  return request;
};

CTAMap.api.getDetail = function (id) {
  var request;
  request = jQuery.ajax({
    url: CTAMap.api.url.detail,
    method: 'POST',
    data: { id: id },
    dataType: 'json',
  });

  return request;
};
